<template>
  <OneTimeCodeForm :custom-verify-code-request="verifyCode" :custom-resend-code-request="resendEmailConfirmationCode" />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import { OneTimeCodeForm, useAuthStore } from '@tallo/auth';
import { useNavigation } from '@tallo/investor/navigation';

const { openOnboarding } = useNavigation();
const authStore = useAuthStore();
const route = useRoute();

const userId = route.query.userId as string;

const verifyCode = async (code: number) => {
  await authStore.investorConfirmEmail(userId, code);
  await openOnboarding();
};

const resendEmailConfirmationCode = async () => {
  await authStore.investorResendEmailConfirmationCode(userId);
};
</script>
